export function formatDate(value?: string): string {
  if (!value) return "-";
  return new Date(value).toLocaleDateString("fr-FR");
}

export function formatDateTime(value?: string): string {
  if (!value) return "-";
  return new Date(value).toLocaleString("fr-FR");
}

export function formatValue(key: string, value: unknown): string {
  if (value === null || value === undefined || value === "") return "-";
  if (key === "date") return formatDate(value as string);
  if (key === "commissionAmount") return `${Number(value).toLocaleString("fr-FR")} XAF`;
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}
